import React, { useEffect, useState } from "react";
import {
  AppModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "../../components/Common/AppOverlay";
import { getData } from "../../helpers/url-request";

const time = (value) =>
  value ? new Date(value).toLocaleString() : "Not recorded";

export default function SecurityHistory() {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [attempt, setAttempt] = useState(0);
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!open) return;
    let active = true;
    setBusy(true);
    setError("");
    setData(null);
    getData(`/user/security-history?page=${page}&pageSize=10`)
      .then((response) => {
        if (!response.status) throw new Error();
        if (active) setData(response.data);
      })
      .catch(() => {
        if (active)
          setError("Unable to load security history. Please try again.");
      })
      .finally(() => {
        if (active) setBusy(false);
      });
    return () => {
      active = false;
    };
  }, [open, page, attempt]);
  return (
    <>
      <button
        className="btn profile-page__link-button"
        type="button"
        onClick={() => {
          setPage(1);
          setOpen(true);
        }}
      >
        View Security History <i className="bx bx-chevron-right" />
      </button>
      <AppModal
        isOpen={open}
        toggle={() => setOpen(false)}
        size="lg"
        style={{ width: "calc(100% - 32px)", maxWidth: "960px" }}
        scrollable
      >
        <ModalHeader toggle={() => setOpen(false)}>
          Security History
        </ModalHeader>
        <ModalBody>
          <p>
            PIERS sign-ins, password changes and failed sign-in attempts for
            your account. Times are shown in your local time zone.
          </p>
          <p className="text-muted small">
            Session endings can include sign-out, expiry or revocation. Password
            events are recorded from this feature's activation onward. Microsoft
            failures cover up to 30 days, subject to Microsoft's retention and
            reporting delay. Changes made outside PIERS are not included.
          </p>
          {data?.warning && (
            <div className="alert alert-warning" role="status">
              {data.warning}
            </div>
          )}
          {busy && <p role="status">Loading security history…</p>}
          {error && (
            <div role="alert">
              {error}{" "}
              <Button type="button" onClick={() => setAttempt((a) => a + 1)}>
                Retry
              </Button>
            </div>
          )}
          {data &&
            (data.items.length === 0 ? (
              <p>No security history is available.</p>
            ) : (
              <>
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Time</th>
                        <th>Event</th>
                        <th>Method</th>
                        <th>Status</th>
                        <th>Ended</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.items.map((item, index) => (
                        <tr key={index}>
                          <td>{time(item.signedInOn)}</td>
                          <td>{item.event || "Browser sign-in"}</td>
                          <td>{item.method}</td>
                          <td>
                            {item.state}
                            {item.current && (
                              <span className="badge bg-primary ms-2">
                                This session
                              </span>
                            )}
                          </td>
                          <td>{item.endedOn ? time(item.endedOn) : "—"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <Button
                    type="button"
                    disabled={page === 1}
                    onClick={() => setPage((p) => p - 1)}
                  >
                    Previous
                  </Button>
                  <span>
                    Page {page} of{" "}
                    {Math.max(1, Math.ceil(data.total / data.pageSize))}
                  </span>
                  <Button
                    type="button"
                    disabled={page * data.pageSize >= data.total}
                    onClick={() => setPage((p) => p + 1)}
                  >
                    Next
                  </Button>
                </div>
              </>
            ))}
        </ModalBody>
        <ModalFooter>
          <Button type="button" onClick={() => setOpen(false)}>
            Close
          </Button>
        </ModalFooter>
      </AppModal>
    </>
  );
}
